export enum Language {
    /**
     * @en Unknown language code
     * @zh 语言代码 - 未知
     */
    UNKNOWN = 'unknown',

    /**
     * @en English language code
     * @zh 语言代码 - 英语
     */
    ENGLISH = 'en',

    /**
     * @en Chinese language code
     * @zh 语言代码 - 中文
     */
    CHINESE = 'zh',

    /**
     * @en French language code
     * @zh 语言代码 - 法语
     */
    FRENCH = 'fr',

    /**
     * @en Italian language code
     * @zh 语言代码 - 意大利语
     */
    ITALIAN = 'it',

    /**
     * @en German language code
     * @zh 语言代码 - 德语
     */
    GERMAN = 'de',

    /**
     * @en Spanish language code
     * @zh 语言代码 - 西班牙语
     */
    SPANISH = 'es',

    /**
     * @en Spanish language code
     * @zh 语言代码 - 荷兰语
     */
    DUTCH = 'du',

    /**
     * @en Russian language code
     * @zh 语言代码 - 俄罗斯语
     */
    RUSSIAN = 'ru',

    /**
     * @en Korean language code
     * @zh 语言代码 - 韩语
     */
    KOREAN = 'ko',

    /**
     * @en Japanese language code
     * @zh 语言代码 - 日语
     */
    JAPANESE = 'ja',

    /**
     * @en Hungarian language code
     * @zh 语言代码 - 匈牙利语
     */
    HUNGARIAN = 'hu',

    /**
     * @en Portuguese language code
     * @zh 语言代码 - 葡萄牙语
     */
    PORTUGUESE = 'pt',

    /**
     * @en Arabic language code
     * @zh 语言代码 - 阿拉伯语
     */
    ARABIC = 'ar',

    /**
     * @en Norwegian language code
     * @zh 语言代码 - 挪威语
     */
    NORWEGIAN = 'no',

    /**
     * @en Polish language code
     * @zh 语言代码 - 波兰语
     */
    POLISH = 'pl',

    /**
     * @en Turkish language code
     * @zh 语言代码 - 土耳其语
     */
    TURKISH = 'tr',

    /**
     * @en Ukrainian language code
     * @zh 语言代码 - 乌克兰语
     */
    UKRAINIAN = 'uk',

    /**
     * @en Romanian language code
     * @zh 语言代码 - 罗马尼亚语
     */
    ROMANIAN = 'ro',

    /**
     * @en Bulgarian language code
     * @zh 语言代码 - 保加利亚语
     */
    BULGARIAN = 'bg',
}
